import { Button, Grid } from '@mui/material'

const SearchButton = ({ text, disbled, onClick }) => {
  return (
    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 2 }} className="transaction-item" sx={{ display: 'flex', alignItems: 'flex-end' }}>
      <Button
        color="primary"
        size="medium"
        variant="contained"
        disabled={disbled}
        onClick={onClick}
      >
        {text}
      </Button>
    </Grid>
  )
}

export default SearchButton
